import React from "react";
import { styled } from "@linaria/react";

import { BREAKPOINTS } from "@/constants";

import Demo, { DemoSliderControl, DemoRadioControl } from "@/components/Demo";

import Snippet from "./Snippet";
import OutputWrapper from "./OutputWrapper";

function VerticalMarginsDemo() {
  return (
    <Demo
      id="vertical-margins-demo"
      initialValues={{
        fontSize: 100,
        unit: "px",
      }}
      outputWrapper={OutputWrapper}
      controls={[
        <DemoSliderControl
          key="fontSize"
          id="fontSize"
          label="Default font size"
          min={100}
          max={300}
          previewRenderer={(val) => `${val}%`}
        />,
        <DemoRadioControl
          key="unit"
          id="unit"
          label="Margin unit"
          options={["px", "rem"]}
        />,
      ]}
      controlPosition="top"
    >
      {({ fontSize, unit }) => {
        const fontSizeX = fontSize / 100;
        const marginMultiple = unit === "px" ? 1 : fontSizeX;

        const headingMarginSize = 32 * marginMultiple;
        const paragraphMarginSize = 16 * marginMultiple;

        return (
          <OuterWrapper>
            <Wrapper>
              <Paragraph style={{ fontSize: fontSizeX + "rem" }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </Paragraph>
              <MarginBlock
                style={{
                  height: paragraphMarginSize,
                }}
              />
              <Paragraph style={{ fontSize: fontSizeX + "rem" }}>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since 1966.
              </Paragraph>
              <MarginBlock
                style={{
                  height: headingMarginSize,
                }}
              />
              <Heading style={{ fontSize: 1.5 * fontSizeX + "rem" }}>
                History
              </Heading>
              <MarginBlock
                style={{
                  height: paragraphMarginSize,
                }}
              />
              <Paragraph style={{ fontSize: fontSizeX + "rem" }}>
                It was popularised in the 1960s with the release of Letraset
                sheets containing Lorem Ipsum passages, and more recently with
                desktop publishing software like Aldus PageMaker including
                versions of Lorem Ipsum.
              </Paragraph>
              <MarginBlock
                style={{
                  height: paragraphMarginSize,
                }}
              />
              <Paragraph style={{ fontSize: fontSizeX + "rem" }}>
                For more information, visit the Lorem Ipsum museum.
              </Paragraph>
            </Wrapper>
          </OuterWrapper>
        );
      }}
    </Demo>
  );
}

const OuterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 45rem;
  overflow: auto;
`;

const Wrapper = styled.div`
  padding: 16px;
  margin-bottom: 1rem;
  text-align: left;

  @media ${BREAKPOINTS.smAndLarger} {
    padding: 32px;
    margin-bottom: 0;
  }
`;

const Paragraph = styled.p``;
const Heading = styled.p``;

const MarginBlock = styled.div`
  height: var(--height);
  background: #f2cea5;
  opacity: 0;
  transition: opacity 250ms;

  ${Wrapper}:hover & {
    opacity: 1;
  }
`;

export default VerticalMarginsDemo;
